import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Outlet } from "react-router-dom";
const Layout = () => {
  return (
    <>
      <Navbar bg="light" variant="light">
        <Container>
          <Navbar.Brand href="/">TodToli</Navbar.Brand>
          <Nav className="me-auto justify-content-end">
            <Nav.Link href="#/terms">Үйлчилгээний нөхцөл</Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <Container>
        <br />
        <br />
        <Outlet />
      </Container>
    </>
  );
};

export default Layout;
